export const ProjConstants = {
  LOCATION_HIE: {
      DEFAULT_HIE: ['state', 'district', 'mandal', 'village', 'borewell'],
      GEO: ['state', 'district', 'mandal', 'college','student']
    },
    LOCATION_CONSTANT_OPTIONS: {
      url: ['entityName', 'entityId'],
      dataType: 'FINALLOCATION',
      child: 'district',
      jsonkey: 'entityName',
      name: 'District'
    }
}

import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

/**
 * Keep all the hardcoded values here.
 * Don't keep the constants here which will change depends on environment use environment files for that.
 */

// api endpoints mapping.


const navigationMapping = {
  FORGOT_PASSWORD: 'forgot-password',
  LOGIN: 'login',
  CHANGE_PASSWORD: 'change-password'
}

const preDefinedResources = ["USER", "APPLICATION", "RESOURCE", "ACTION", "ROLE", "CUSTOMER", "LOGIN"];

const keycloakErrorMessages = {
  incomingMobileNoError : 'Duplicate entry',
  displayedmobileNoErrorMsg : 'The Mobile Number already exists'
}

const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

const operationTypes = {
  CUSTOMER: {
    ADD_CUSTOMER: 'add_customer',
    EDIT_CUSTOMER: 'edit_customer',
    DELETE_CUSTOMER: 'delete_customer'
  },
  PROFILE: {
    ADD_PROFILE: 'add_profile',
    EDIT_PROFILE: 'edit_profile',
    DELETE_PROFILE: 'delete_profile'
  },
  USER: {
    ADD_USER: 'add_user',
    EDIT_USER: 'edit_user',
    DELETE_USER: 'delete_user',
  },
  ALLOCATE_APPLICATIONS : {
    ASSIGN_APPLICATIONS : 'Assign Applications',
    UPDATE_APPLICATIONS : 'Update Applications'
  },
  ALLOCATE_RESOURCES : {
    ASSIGN_RESOURCES : 'Assign Resources',
    UPDATE_RESOURCES : 'Update Resources',
    ASSIGN_RESOURCES_TITLE : 'Assign Resources For Applications',
    UPDATE_RESOURCES_TITLE : 'Update Resources For Applications'
  }
}

const infiniteScrollOptions = {
  SCROLL_LIMIT : 2,
  SCROLL_DISTANCE: 2,
  THROTTLE: 50,
  SCROLL_ON_WINDOW: false,
  INFINITE_SCROLL_DISABLED: false,
  INFINITE_SCROLL_LIMIT : 20
}

const redirectToOtherAppsOptions = {
  appName : 'Kredos AI',
  appUrl : 'kredos-ai'
}

const OPTIONS = {
  VIEW: 'View',
  EDIT: 'Edit',
  DELETE: 'Delete'
};

const CONTENT_OPTIONS = {
  'customer': 'Customer',
  'roles': 'Role',
  'profiles': 'Role',
  'administrators': 'Administrator',
  'users': 'User',
  'applications': 'Application',
  'resources': 'Resource',
  'actions': 'Action'
}

const listOfUrls = [
  'URL1',
  'URL2',
  'URL3',
  'URL4',
  'URL5',
]

const resourceTypes = ["APIs", "URLs", "Dashboards", "Widgets"];

const resourceTypesMap = {
  "API": "APIs",
  "URL": "URLs",
  "DASHBOARD": "Dashboards",
  "WIDGET": "Widgets"
}

const applicationURLS = [
  { label: 'Application1', value: 'Application1', isChecked: false },
  { label: 'Application2', value: 'Application2', isChecked: false },
  { label: 'Application3', value: 'Application3', isChecked: false },
  { label: 'Application4', value: 'Application4', isChecked: false },
  { label: 'Application5', value: 'Application5', isChecked: false }
]
const CUSTOMERS = [
  { label: 'Customer1', value: 'customer1', isChecked: false },
  { label: 'Customer2', value: 'customer2', isChecked: false },
  { label: 'Customer3', value: 'customer3', isChecked: false },
  { label: 'Customer4', value: 'customer4', isChecked: false },
  { label: 'Customer5', value: 'customer5', isChecked: false },
  { label: 'Customer6', value: 'customer6', isChecked: false },
  { label: 'Customer7', value: 'customer7', isChecked: false },
  { label: 'Customer8', value: 'customer8', isChecked: false }

];

const PROFILES = [
  { label: 'Profile1', value: 'profile1', isChecked: false },
  { label: 'Profile2', value: 'profile2', isChecked: false },
  { label: 'Profile3', value: 'profile3', isChecked: false },
  { label: 'Profile4', value: 'profile4', isChecked: false },
  { label: 'Profile5', value: 'profile5', isChecked: false },
  { label: 'Profile6', value: 'profile6', isChecked: false },
  { label: 'Profile7', value: 'profile7', isChecked: false },
  { label: 'Profile8', value: 'profile8', isChecked: false }

]

const resourceURLS = [
  'Resource1',
  'Resource2',
  'Resource3',
  'Resource4',
  'Resource5',
]

const modalStatus = {
  ACTIVE: 'Active'
}

const ROLES = [{ label: 'Read', value: 'Read', isChecked: false },
{ label: 'Write', value: 'Write', isChecked: false },
{ label: 'Approve', value: 'Approve', isChecked: false }];

const modalOptions: NgbModalOptions = {
  windowClass: 'modal-form',
  centered: true,
  size: 'md'
}

const modalOptionsSmall: NgbModalOptions = {
  windowClass: 'modal-form',
  centered: true,
  size: 'sm'
}

const editModalOptions: NgbModalOptions = {
  windowClass: 'modal-form',
  centered: true,
  size: 'lg'
}

const otpModalOptions: NgbModalOptions = {
  backdrop: 'static',
  windowClass: 'backgroundTransparent my-class'
}
const deletePopupOptions: NgbModalOptions = {
  windowClass: 'alert-popup',
  centered: true,
  backdrop: 'static',
  size: 'sm'
}

const ACCESS_TYPE_LIST = {
  LOCAL: "local",
  PROD: "prod"
}

const ROLES_CNST = {
  SU: 'SuperUser',
  SM: 'SeniorManager',
}

const COMMON_ROUTE_MAPPING = {
  LOGIN: ['login'],
  SIGNIN: ["um", "authentication", "signIn"],
  USERPAGE: ["um", "users"]
}

const DEFAULT_USER = {
  firstName: 'Madhu',
  userPrincipalName: 'madhu123@gpac.com'
}


const TOASTR_CNST = {
  closeButton: false,
  timeOut: 3000,
  extendedTimeOut: 2000
};

const LANDING_PAGE = {
  'SuperUser': "users",
}

const SOME_COMMON_LABELS = {
  LOGIN_PATH: "/login",
}

const LIST_NAME_MAPPING = {
  USER_LIST: 'userlist',
  ROLE_LIST: 'rolelist',
  PROFILE_LIST: 'profilelist',
  ADMIN_LIST: 'adminlist',
  CUSTOMER_LIST: 'customerlist',
  RESOURCE_LIST: ' resourcelist',
  ACTION_LIST: 'actionlist',
  PROFILE_CUSTOMER_LIST: 'profilelistcustomer',
  USER_CUSTOMER_LIST: 'usercustomerlist'

}

const STATUS_TYPE_LIST = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive'
}

const customerAdminRoleName = 'Customer Administrator';
const customerServiceExecutive = 'Customer Service Executive';

const configLabelNames = {
  EDIT_USER : 'editUser'
}

const KEYCLOAK_BASE_URL = 'http://localhost:8080/auth';
const KEYCLOAK_REDIRECT_URL = 'http://localhost:5200/landing-page';
const KEYCLOAK_LOGOUT_URL = 'http://localhost:5200/login';

const keyCloakOptions = {
  CLIENT_ID : 'hattrick',
  REALM: 'stanley',
  URL : KEYCLOAK_BASE_URL,
  REDIRECT_URL : KEYCLOAK_REDIRECT_URL,
  LOGOUT_URL : KEYCLOAK_LOGOUT_URL
}

const popOverOptions = {
  HEADER_THRESHOLD : 9,
  STANDARD_SIZE : 4
}


const validationTimer = 20

const currentApplication = 'User Management';

const superAdmin = 'Super Administrator';

const domainsRequiringUserId = ['get_user_permissions'];

const ORDER_FOR_VIEW_USERS = {
  "activationDate" : 5,
  "email" : 3,
  "firstName" : 1,
  "lastName" : 2,
  "lastLogin" : 6,
  "status" : 7,
  "username" : 8,
  "mobileNumber" : 9,
  "title" : 4
}

const EDIT_USER_ADD_ROLE= {
  "d9168e72-9bc7-4627-854e-dec9e6952fb1": {
      "scope": [
          {
              "scopeType": "NON_HIERARCHY",
              "scopeName": "Application",
              "scopeValue": []
          }
      ]
  }
}

const errorMessages = {
  'CUST_ADMIN_GENERAL' : 'Error occured while creating customer admin'
}

const customerModuleOperations = {
  'ADD_CUSTOMER' : 'new',
  'UPDATE_CUSTOMER': 'edit',
  'VIEW_CUSTOMER': 'view'
}

const userModuleOperations = {
  'ADD_USER' : 'new',
  'UPDATE_USER': 'edit',
  'VIEW_USER': 'view'
}

const roleModuleOperations = {
  'ADD_ROLE' : 'new',
  'UPDATE_ROLE': 'edit',
  'VIEW_ROLE': 'view'
}

const conflictString = "Conflict:";

const actionNameMapping = {
  READ: "R",
  EDIT: "E"
}

export const USER_MGMT_CNST = {
  NAVIGATION_MAPPING: navigationMapping,
  INFINITE_SCROLL_OPTIONS: infiniteScrollOptions,
  OPTIONS: OPTIONS,
  MODAL_OPTIONS: modalOptions,
  SMALL_MODAL_OPTIONS: modalOptionsSmall,
  LIST_OF_URLS: listOfUrls,
  APPLICATION_URLS: applicationURLS,
  RESOURCE_URLS: resourceURLS,
  MODAL_STATUS: modalStatus,
  ACCESS_TYPE: ACCESS_TYPE_LIST.LOCAL,//(local or prod)
  ACCESS_ROLE: ROLES_CNST.SU,
  EDIT_MODAL_OPTIONS: editModalOptions,
  DELETE_POPUP_OPTIONS: deletePopupOptions,
  ACCESS_TYPE_LIST,
  COMMON_ROUTE_MAPPING,
  DEFAULT_USER,
  TOASTR_CNST,
  LANDING_PAGE,
  SOME_COMMON_LABELS,
  ROLES_CNST,
  ROLES,
  CUSTOMERS,
  CONTENT_OPTIONS,
  LIST_NAME_MAPPING,
  OPERATION_TYPES: operationTypes,
  PROFILES,
  STATUS_TYPE_LIST,
  CURRENT_APPLICATION: currentApplication,
  KEYCLOAK_ERROR_MSGS : keycloakErrorMessages,
  DOMAINS_NEEDING_USER_ID: domainsRequiringUserId,
  VALIDATION_CONSTANT: validationTimer,
  OTP_MODAL_OPTIONS: otpModalOptions,
  KEYCLOAK_OPTIONS : keyCloakOptions,
  ORDER_FOR_VIEW_USERS,
  SUPER_ADMIN: superAdmin,
  CUSTOMER_ADMIN_ROLE : customerAdminRoleName,
  CUSTOMER_SERVICE_EXECUTIVE : customerServiceExecutive,
  CONFIG_LABELS : configLabelNames,
  EDIT_USER_ADD_ROLE,
  PREDEFINED_RESOURCES : preDefinedResources,
  RESOURCE_TYPES : resourceTypes,
  RESOURCE_TYPES_MAP : resourceTypesMap,
  ERROR_MESSAGES : errorMessages,
  CONFLICT_STRING : conflictString,
  POPOVER_OPTIONS : popOverOptions,
  REDIRECT_TO_OTHER_APPS : redirectToOtherAppsOptions,
  MONTH_NAMES : monthNames,
  CUSTOMER_MODULE_OPERATIONS : customerModuleOperations,
  USER_MODULE_OPERATIONS : userModuleOperations,
  ROLE_MODULE_OPERATIONS : roleModuleOperations,
  ACTION_NAME_MAPPING: actionNameMapping
};



const loginDefaultConfig = {
  title: "LOGIN",
  fieldsLabel: {
    usrname: 'UserName',
    pswd: 'Password'
  },
  validationMsgs: {
    username: 'Username is Required',
    pswd: 'Password is Required'
  },
  placeHolders: {
    userName: "Enter Username",
    password: "Enter Password"
  },
  forgotPswd: "Forgot Password?",
  reset: {
    label: "Reset",
    show: true
  },
  submit: {
    label: "Login"
  }
}

const logoDefaultConfig = {
  image: {
    src:"assets/imgs/new.png"
  },
  loginText: {
    text: "Login"
  }
}
const forgotPswdDefaultConfig = {
  title: "Forgot Password",
  label: {
    userName: "User Name"
  },
  cancelBtn: {
    label: "Cancel"
  },
  submitBtn: {
    label: "Request Verification code"
  },
  validationMessages: {
    userName: "Username is required"
  },
  placeHolder: {
    username: "Enter UserName"
  }

}
const otpForgotPswdDefaultConfig = {
  title: "Verification code Validation",
  otpValidationForm: {
    otp: "Verification Code",
    newPassword: "Create New Password",
    confirmPassword: "Confirm New Password"
  },
  validatingMsgs: {
    otp: "Please enter valid Verification code",
    newPswd: "Password is required",
    numberOnly: "Number Only",
    confirmNewPswd: "Confirm Password is required",
    mustMatch: "Password Must be match",
    mustValid: "Password must be at least 6 characters"
  },
  placeHolders: {
    otp: "Enter Verification Code",
    newPswd: "Enter New Password",
    confirmPswd: "Confirm New Password"
  },
  backBtn: {
    label: "Back"
  },
  submitBtn: {
    label: "Submit"
  },
  resendBtn: {
    label: "Resend?"
  }
}

export const changePswdDefaultConfig = {
  title: "Change Password",
  changePassword: {
    oldPassword: "Old Password",
    newPassword: "New Password",
    confirmPassword: "Confirm New Password"
  },

  validatingMsgs: {
    oldPswd: "Password is required",
    newPswd: "Password is required",
    mustValid: "Password must be at least 6 characters",
    confirmNewPswd: "Confirm Password is required",
    mustMatch: "Password Must be match"
  },
  placeHolders: {
    oldPswd: "Enter Your Old Password",
    newPswd: "Enter New Password",
    confirmNewPswd: "Confirm Password"
  },
  resetBtn: {
    label: "Reset"
  },
  submitBtn: {
    label: "Submit"
  }
}

export const otpChangePswdDefaultConfig = {
  title: "Verification code Validation",
  otpValForChangePswd: {
    label: "Enter OTP"
  },
  validateMsg: {
    otp: "Please enter valid Verification Code",
    numberOnly: "Number Only"
  },
  placeHolder: {
    otp: "Enter OTP"
  },
  resend: {
    label: "Resend?"
  },
  backBtn: {
    label: "Back"
  },
  submitBtn: {
    label: "Submit"
  }
}

const addUserDefaultConfig = {

  title: "Add New User",
  addUser: {
    firstName: {
      title: "First Name",
      class: "col-sm-6 col-lg-3",
      inputType: "text"

    },
    lastName: {
      title: "Last Name",
      class: "col-sm-6 col-lg-3",
      inputType: "text"

    },
    username: {
      title: "User Name",
      class: "col-sm-6 col-lg-3",
      inputType: "text"

    },
    email: {
      title: "Email",
      class: "col-sm-6 col-lg-3",
      inputType: "email"

    },
    mobileNo: {
      title: "Mobile Number",
      class: "col-sm-6 col-lg-3",
      inputType: "text"
    },
    cancelBtn: {
      title: "Cancel"
    },
    addBtn: {
      title: "Add"
    }
  },
  placeHolder: {
    firstName: {
      label: "Enter First Name"
    },
    lastName: {
      label: "Enter Last Name"
    },
    userName: {
      label: "Enter User Name"
    },
    email: {
      label: "Email"
    },
    mobileNo: {
      label: "Enter mobile No"
    }
  }
}

export const USER_MGMT_DEFAULT_CONFIG_CNST = {
  LOGIN_DEFAULT_CNST: loginDefaultConfig,
  LOGO_DEFAULT_CNST: logoDefaultConfig,
  FORGOT_PSWD_CONST: forgotPswdDefaultConfig,
  OTP_FORGOT_PSWD_CONST: otpForgotPswdDefaultConfig,
  CHANGE_PSWD_CONST: changePswdDefaultConfig,
  OTP_CHANGE_PASSWORD_CNST: otpChangePswdDefaultConfig,
  ADD_USER_CONST: addUserDefaultConfig
}
